import React from 'react';

export const QuoLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="49"
    height="28"
    viewBox="0 0 49 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.3692 4.32537C43.1937 4.32537 44.6774 5.80989 44.6774 7.63515V16.0645C44.6774 17.8897 43.1937 19.3742 41.3692 19.3742C39.5447 19.3742 38.0607 17.8897 38.0607 16.0645V7.63515C38.0607 5.80989 39.5447 4.32537 41.3692 4.32537ZM41.3692 0C37.1543 0 33.7383 3.41845 33.7383 7.63433V16.0636C33.7383 20.2803 37.1552 23.698 41.3692 23.698C45.5841 23.698 49.0001 20.2795 49.0001 16.0636V7.63433C49.0001 3.41765 45.5832 0 41.3692 0Z"
      fill="#0E0F17"
    />
    <path
      d="M27.9855 0.564453V16.0643C27.9855 17.9876 26.4216 19.5514 24.5001 19.5514C22.5785 19.5514 21.0145 17.9868 21.0145 16.0643V0.564453H16.8691V16.0643C16.8691 20.281 20.2861 23.6988 24.5001 23.6988C28.7149 23.6988 32.131 20.2802 32.131 16.0643V0.564453H27.9855Z"
      fill="#0E0F17"
    />
    <path
      d="M7.63093 4.32537C9.45537 4.32537 10.9393 5.80989 10.9393 7.63515V16.0645C10.9393 17.8897 9.45537 19.3742 7.63093 19.3742C5.80651 19.3742 4.32263 17.8897 4.32263 16.0645V7.63515C4.32263 5.80989 5.80651 4.32537 7.63093 4.32537ZM7.63093 0C3.41694 0 0 3.41845 0 7.63433V16.0636C0 20.2803 3.41694 23.698 7.63093 23.698C11.8458 23.698 15.2619 20.2795 15.2619 16.0636V7.63433C15.2627 3.41845 11.8458 0 7.63093 0Z"
      fill="#0E0F17"
    />
    <path
      d="M15.3528 27.7732C11.724 28.0096 10.4786 26.0549 4.91724 26.0549C5.32523 24.6372 5.81909 23.327 6.24852 21.9092C10.8222 21.8233 12.4326 23.778 16.6412 23.606C16.3853 24.5661 15.7693 26.4797 15.3612 27.7472L15.3528 27.7732Z"
      fill="#0E0F17"
    />
  </svg>
);
